import { render, staticRenderFns } from "./commodityAttr.vue?vue&type=template&id=4b8632c2&scoped=true&"
import script from "./commodityAttr.vue?vue&type=script&lang=js&"
export * from "./commodityAttr.vue?vue&type=script&lang=js&"
import style0 from "./commodityAttr.vue?vue&type=style&index=0&id=4b8632c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8632c2",
  null
  
)

export default component.exports